<template>
  <b-container data-aos="fade-up">
    <b-img-lazy
      class="w-100"
      alt="Picture of a house with a local notice board in the foreground"
      src="../../assets/latest-news.jpg"
    />
    <h1 class="mt-5 mb-4 text-primary">Local News</h1>
    <p>
      <i>
        Check out this page for information about the Car Scheme as well as
        other local events and activities which are going on in our six villages
        of Thorney, Harby, Wigsley, N&amp;S Clifton and Spalford.
      </i>
    </p>
    <b-row>
      <b-col md="4" xl="3" class="mb-3">
        <b-card
          title="Winner of the 100th Trip!"
          class="h-100"
          sub-title="Congratulations to Doreen and George from Thorney who were the lucky winners of the 100th Trip completed by the Car Scheme since our launch in April 2017."
          img-src="../../assets/news/flowers.jpg"
          img-alt="Picture of a bunch of flowers"
          img-top
        >
          <template #footer>
            <b-btn
              class="float-right"
              variant="primary"
              to="/news/winner-100th-trip"
            >
              <font-awesome-icon icon="eye" class="mr-1" />Read
            </b-btn>
          </template>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" class="mb-3">
        <b-card
          title="Could you be our 100th passenger?"
          class="h-100"
          sub-title="The Scheme is gaining in popularity with a total of 37 passengers registered and using the service."
          img-src="../../assets/news/th2.jpg"
          img-alt="Picture of a celebration"
          img-top
        >
          <template #footer>
            <b-btn
              variant="primary"
              class="float-right"
              to="/news/could-you-be-our-100th-passenger"
            >
              <font-awesome-icon icon="eye" class="mr-1" />Read
            </b-btn>
          </template>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" class="mb-3">
        <b-card
          title="Not just a Car Scheme"
          class="h-100"
          sub-title="Drivers and passengers joined partners and friends to enjoy an excellent Christmas lunch at the White Hart at North Scarle in early December."
          img-src="../../assets/news/Xmas1.jpg"
          img-alt="Picture of a group of people eating Christmas dinner"
          img-top
        >
          <template #footer>
            <b-btn
              class="float-right"
              variant="primary"
              to="/news/not-just-a-car-scheme"
            >
              <font-awesome-icon icon="eye" class="mr-1" />Read
            </b-btn>
          </template>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" class="mb-3">
        <b-card
          title="Drivers Get Together"
          class="h-100"
          sub-title="Being a volunteer driver can be good fun! Meeting people from your own and other villages is great."
          img-src="../../assets/news/contact-thaw.jpg"
          img-alt="Picture of a group of people stood around a BBQ"
          img-top
        >
          <template #footer>
            <b-btn
              class="float-right"
              variant="primary"
              to="/news/drivers-get-together"
            >
              <font-awesome-icon icon="eye" class="mr-1" />Read
            </b-btn>
          </template>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" class="mb-3">
        <b-card
          title="TH&W Is Growing"
          class="h-100"
          sub-title="Since the launch of the Car Scheme we've recruited 17 drivers eager to offer transport to people living in our five villages."
          img-src="../../assets/news/thaw-growing.jpg"
          img-alt="Picture of a driver and passenger stood by a car"
          img-top
        >
          <template #footer>
            <b-btn
              class="float-right"
              variant="primary"
              to="/news/thaw-growing"
            >
              <font-awesome-icon icon="eye" class="mr-1" />Read
            </b-btn>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "NewsHome",
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-img-top {
  height: 170px;
  object-fit: cover;
}
</style>
